// extracted by mini-css-extract-plugin
module.exports = {"cards":"_6c97079b1b--cards--3DkkO"};